import { Injectable } from '@angular/core';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './actions';

@Injectable({
	providedIn: 'root',
})
export class LawyerSearchDispatch {
	@Dispatch()
	Search = (payload: {
		searchValue: string;
		lawFirmId?: string;
		cardId?: string;
		role?: string;
	}): actions.Search => new actions.Search(payload);
}
